"use strict";
/**
 * API Response Types - Industry Best Practices
 *
 * LEARNING POINTS:
 *
 * 1. **Discriminated Unions**:
 *    - TypeScript can narrow types based on discriminant field (`ok`)
 *    - if (response.ok) → TypeScript knows it's ApiSuccessResponse
 *    - if (!response.ok) → TypeScript knows it's ApiErrorResponse
 *
 * 2. **Base Types + Extensions**:
 *    - Common fields in base interface
 *    - Specific fields in extended interfaces
 *    - Keeps code DRY and maintainable
 *
 * 3. **Type Safety**:
 *    - No runtime checks needed for type narrowing
 *    - Compiler prevents accessing wrong fields
 *    - Example: Can't access response.data on error response
 *
 * 4. **Industry Standards**:
 *    - Based on JSON:API, REST best practices
 *    - Similar to what Google, Stripe, GitHub use
 *    - Extensible for future needs (versioning, etc.)
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_TYPES = exports.API_STATUS = void 0;
// ============================================================================
// COMMON STATUS STRINGS (Optional - for consistency)
// ============================================================================
/**
 * Standard HTTP status strings
 * Use these for consistency across the API
 */
exports.API_STATUS = {
    // 2xx Success
    OK: 'OK',
    CREATED: 'CREATED',
    ACCEPTED: 'ACCEPTED',
    NO_CONTENT: 'NO_CONTENT',
    // 4xx Client Errors
    BAD_REQUEST: 'BAD_REQUEST',
    UNAUTHORIZED: 'UNAUTHORIZED',
    FORBIDDEN: 'FORBIDDEN',
    NOT_FOUND: 'NOT_FOUND',
    CONFLICT: 'CONFLICT',
    UNPROCESSABLE_ENTITY: 'UNPROCESSABLE_ENTITY',
    // 5xx Server Errors
    INTERNAL_ERROR: 'INTERNAL_ERROR',
    SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE'
};
/**
 * Standard error types
 * Use these for consistency in error handling
 */
exports.ERROR_TYPES = {
    VALIDATION_ERROR: 'ValidationError',
    BUSINESS_RULE_ERROR: 'BusinessRuleError',
    NOT_FOUND_ERROR: 'NotFoundError',
    UNAUTHORIZED_ERROR: 'UnauthorizedError',
    FORBIDDEN_ERROR: 'ForbiddenError',
    CONFLICT_ERROR: 'ConflictError',
    INTERNAL_ERROR: 'InternalError'
};
